import { AccelaPermitConditions } from 'types';

export const isPermitWithSwo = (permits: AccelaPermitConditions[]) => {
  return permits.find((permit) => permit.hasSwo)?.swoSetAt || null;
};

export const hasPermitSwo = (permitId: string, permits: AccelaPermitConditions[]): boolean => {
  return Boolean(permits.find((permit) => permit.id === permitId && permit.hasSwo));
};
